/**
 * External Dependencies
 */
import 'jquery';

$('.hamburger').click(function() {
  $(this).toggleClass('active');
  $('body').toggleClass('hamburger-active overflow-hidden');
  $('.hamburger-bg').toggleClass('opacity-0 opacity-30 invisible');
});

$('.hamburger-bg').click(function() {
  $('.hamburger').toggleClass('active');
  $('body').toggleClass('hamburger-active overflow-hidden');
  $('.hamburger-bg').toggleClass('opacity-30 opacity-0 invisible');
});

// HAMBURGER
$('.mobile-nav ul li.menu-item-has-children').click(function() {
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
  } else {
    $('.mobile-nav ul li.menu-item-has-children').removeClass('active');
    $(this).addClass('active');
  }
});

$('.gform_drop_instructions').html('');

$('#gfield_description_1_5').appendTo('#field_1_5 .gfield_label');

// SCROLLED
$(window).on('scroll', function() {
  if ($(window).scrollTop() > 1) {
    $('body').addClass('scrolled');
  }
  else {
    $('body').removeClass('scrolled');
  }
});
